"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialStatisticsDetails = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const component_1 = require("../../../../components/site-menu/component");
//@ts-ignore                
let rwsTemplate = T.html `<div class="tutorial-statistics-page">
    <div class="page-head">
        <div>
            <h1>${() => 'tutorial.statistics.title'.t()}</h1>
            <h2>${x => x.tutorialName}</h2>
        </div>
        <div class="page-actions">
            <button class="btn btn-outline-secondary" @click="${x => x.backToList()}">
                ${() => 'tutorial.statistics.back'.t()}
            </button>
            <button class="btn btn-primary" ?disabled="${x => x.loading}" @click="${x => x.loadData()}">
                ${() => 'tutorial.statistics.refresh'.t()}
            </button>
        </div>
    </div>
    <div class="card p-3">
        ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `<app-loader block="true"></app-loader>`)}
        ${(0, fast_element_1.when)(x => !!x.error, (0, fast_element_1.html) `<div class="alert alert-danger" role="alert">${x => x.error}</div>`)}
        ${(0, fast_element_1.when)(x => !x.loading && !x.error, (0, fast_element_1.html) `
            <p>${() => 'tutorial.statistics.participants'.t()}: ${x => x.participants.length}</p>
            <p class="text-muted">${() => 'tutorial.statistics.progressExplanation'.t()}</p>
            ${(0, fast_element_1.when)(x => x.participants.length === 0, (0, fast_element_1.html) `
                <p class="empty-state">${() => 'tutorial.statistics.emptyParticipants'.t()}</p>
            `)}
            ${(0, fast_element_1.when)(x => x.participants.length > 0, (0, fast_element_1.html) `
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col">${() => 'tutorial.statistics.participant'.t()}</th>
                                <th scope="col">${() => 'tutorial.statistics.identity'.t()}</th>
                                <th scope="col">${() => 'tutorial.statistics.currentStep'.t()}</th>
                                <th scope="col">${() => 'tutorial.statistics.currentSection'.t()}</th>
                                <th scope="col">${() => 'tutorial.statistics.tasks'.t()}</th>
                                <th scope="col">${() => 'tutorial.statistics.progress'.t()}</th>
                                <th scope="col">${() => 'actions'.t()}</th> 
                            </tr>
                        </thead>
                        <tbody>
                            ${(0, fast_element_1.repeat)(x => x.participants, (0, fast_element_1.html) `
                                <tr>
                                    <td>${x => x.name}</td>
                                    <td>${x => (x.userIdentity ? 'tutorial.statistics.registered' : 'tutorial.statistics.guest').t()}</td>
                                    <td>${x => x.step ? x.step.number + '. ' + x.step.title : 'tutorial.statistics.notStarted'.t()}</td>
                                    <td>${x => x.section ? (x.step ? x.step.number + '.' : '') + x.section.number + ' ' + x.section.title : 'tutorial.statistics.notStarted'.t()}</td>
                                    <td>${x => x.completedTasks} / ${x => x.totalTasks}</td>
                                    <td>
                                        ${(0, fast_element_1.when)(x => x.percentage !== null, (0, fast_element_1.html) `
                                            <div class="progress">
                                                <div class="progress-bar" role="progressbar"
                                                    aria-label="${() => 'tutorial.statistics.progress'.t()}"
                                                    aria-valuenow="${x => x.percentage}" aria-valuemin="0" aria-valuemax="100"
                                                    style="width: ${x => x.percentage}%"></div>
                                            </div>
                                            <span>${x => x.percentage}%</span>
                                        `)}
                                        ${(0, fast_element_1.when)(x => x.percentage === null, (0, fast_element_1.html) `
                                            <span class="text-muted">${() => 'tutorial.statistics.noTasks'.t()}</span>
                                        `)}
                                    </td>
                                    <td>
                                        <button class="btn btn-outline-primary" @click="${(x, c) => c.parent.openModal(x.uuid)}">
                                            <i class="simple-icon-magnifier"></i>
                                            
                                        </button>
                                    </td>
                                </tr>
                            `)}
                        </tbody>
                    </table>
                </div>
            `)}
        `)}
    </div>
    ${(0, fast_element_1.when)(x => x.openedModal, (0, fast_element_1.html) `
    <rws-modal header="tutorial.statistics.time_data" centerTop="false" :closeModal="${x => x.closeModal.bind(x)}">
        ${(0, fast_element_1.when)(x => x.modalData.length > 0, (0, fast_element_1.html) `
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">${() => 'tutorial.form.step'.t()}</th>
                            <th scope="col">${() => 'tutorial.form.section'.t()}</th>
                            <th scope="col">${() => 'tutorial.statistics.time'.t()}</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        ${(0, fast_element_1.repeat)(x => x.modalData, (0, fast_element_1.html) `
                            <tr>
                                <td>${x => x.tutorialSection.tutorialStep.order} ${x => x.tutorialSection.tutorialStep.title}</p></td>
                                <td>${x => x.tutorialSection.tutorialStep.order}.${x => x.tutorialSection.order} ${x => x.tutorialSection.title}</td>
                                <td>
                                    ${(x, c) => c.parent.printTime(x.time)}
                                </td>
                            </tr>
                        `)}
                    </tbody>
                </table>
            </div>
        `, (0, fast_element_1.html) `<p class="text-center alert alert-warning">${() => 'tutorial.statistics.time.noData'.t()}</p>`)}
    </rws-modal>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.tutorial-statistics-page {
  padding: 1.5rem;
}
.tutorial-statistics-page .page-head, .tutorial-statistics-page .page-actions, .tutorial-statistics-page .search-form, .tutorial-statistics-page .pagination-bar {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.tutorial-statistics-page .page-head {
  justify-content: space-between;
  margin-bottom: 1.5rem;
}
.tutorial-statistics-page .table-responsive {
  overflow-x: auto;
}
.tutorial-statistics-page .table {
  width: 100%;
}
.tutorial-statistics-page .table th, .tutorial-statistics-page .table td {
  padding: 1rem;
  vertical-align: middle;
}
.tutorial-statistics-page .table td p {
  margin: 0.5rem 0 0;
  max-width: 40rem;
}
.tutorial-statistics-page .progress {
  min-width: 8rem;
  height: 0.75rem;
  margin-bottom: 0.25rem;
}
.tutorial-statistics-page .empty-state {
  padding: 2rem;
  text-align: center;
}
.tutorial-statistics-page .pagination-bar {
  justify-content: center;
  margin-top: 1rem;
}`;
const shadowOptions = { "mode": "open" };
let TutorialStatisticsDetails = class TutorialStatisticsDetails extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.tutorialName = '';
        this.participants = [];
        this.loading = false;
        this.error = '';
        this.openedModal = false;
        this.modalData = [];
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadData();
    }
    async loadData() {
        if (this.loading)
            return;
        this.loading = true;
        this.error = '';
        this.tutorialName = '';
        this.participants = [];
        try {
            const id = this.routeParams.id;
            if (!id) {
                throw new Error('Missing tutorial ID');
            }
            const response = await this.apiService.back.get('tutorial.statistics.list', {
                routeParams: { id }
            });
            if (!(response === null || response === void 0 ? void 0 : response.success) || !response.data) {
                throw new Error((response === null || response === void 0 ? void 0 : response.error) || 'tutorial.statistics.loadFailed'.t());
            }
            this.tutorialName = response.data.tutorialName;
            this.participants = response.data.participants;
        }
        catch (error) {
            console.error('Failed to load tutorial statistics:', error);
            this.error = 'tutorial.statistics.loadFailed'.t();
            this.notifyService.notify(this.error, 'error');
        }
        finally {
            this.loading = false;
        }
    }
    backToList() {
        component_1.SiteMenu.goto.bind(this)('/settings/tutorial-statistics');
    }
    async openModal(participantId) {
        this.modalData = (await this.apiService.back.get('tutorial.participant.time', {
            routeParams: { uuid: participantId }
        })).data || [];
        this.openedModal = true;
    }
    closeModal() {
        this.openedModal = false;
        this.modalData = [];
    }
    printTime(time) {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;
        return `${hours}h ${minutes}m ${seconds}s`;
    }
};
exports.TutorialStatisticsDetails = TutorialStatisticsDetails;
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsDetails.prototype, "tutorialName", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialStatisticsDetails.prototype, "participants", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsDetails.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsDetails.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], TutorialStatisticsDetails.prototype, "openedModal", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialStatisticsDetails.prototype, "modalData", void 0);
exports.TutorialStatisticsDetails = TutorialStatisticsDetails = __decorate([
    (0, client_1.RWSView)('tutorial-statistics-details', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TutorialStatisticsDetails);
TutorialStatisticsDetails.defineComponent();
